var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.707,0.293C9.52,0.105 9.265,-0 9,0L2.6,0C1.91,0 1.249,0.274 0.762,0.761C0.762,0.761 0.762,0.762 0.762,0.762C0.274,1.249 0,1.91 0,2.6L0,15.4C0,16.089 0.274,16.751 0.761,17.238C0.762,17.239 0.762,17.239 0.762,17.239C1.249,17.726 1.91,18 2.6,18C2.6,18 12.2,18 12.2,18C12.89,18 13.551,17.726 14.038,17.239C14.526,16.751 14.8,16.089 14.8,15.4L14.8,5.8C14.8,5.535 14.695,5.28 14.507,5.093L9.707,0.293ZM8.2,2L2.6,2C2.441,2 2.288,2.063 2.176,2.176C2.063,2.288 2,2.441 2,2.6C2,2.6 2,15.4 2,15.4C2,15.559 2.063,15.712 2.176,15.824C2.288,15.937 2.441,16 2.6,16L12.2,16C12.359,16 12.512,15.937 12.624,15.824C12.737,15.712 12.8,15.559 12.8,15.4L12.8,6.6L9,6.6C8.558,6.6 8.2,6.242 8.2,5.8L8.2,2ZM10.6,12.2L4.2,12.2C3.758,12.2 3.4,12.558 3.4,13C3.4,13.442 3.758,13.8 4.2,13.8L10.6,13.8C11.042,13.8 11.4,13.442 11.4,13C11.4,12.558 11.042,12.2 10.6,12.2ZM10.6,9L4.2,9C3.758,9 3.4,9.358 3.4,9.8C3.4,10.241 3.758,10.6 4.2,10.6L10.6,10.6C11.042,10.6 11.4,10.241 11.4,9.8C11.4,9.358 11.042,9 10.6,9ZM5.8,5.8L4.2,5.8C3.758,5.8 3.4,6.158 3.4,6.6C3.4,7.041 3.758,7.4 4.2,7.4L5.8,7.4C6.242,7.4 6.6,7.041 6.6,6.6C6.6,6.158 6.242,5.8 5.8,5.8ZM11.586,5L9.8,3.214L9.8,5L11.586,5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.6f63972004710804216381a8123f8068.svg";
export { ForwardRef as ReactComponent };